import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const SignUpPageAsync = lazy(() => import('./ui/SignUpPage'));

export const SignUpPage = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <SignUpPageAsync />
    </Suspense>
  );
};
